module.exports = __webpack_public_path__ + "static/bike-self-zoom-a48d892d569cd08e9b612b6fff3fe649.jpg";